module.exports = __webpack_public_path__ + "img/background.bc78f36a.png";